import { render, staticRenderFns } from "./SharedFolderLink.vue?vue&type=template&id=64b83258&"
import script from "./SharedFolderLink.vue?vue&type=script&lang=js&"
export * from "./SharedFolderLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports